import 'typeface-roboto';
import 'typeface-roboto-condensed';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import '../scss/App.scss';

ReactDOM.render(<App />, document.getElementById('root'));
